export default __webpack_public_path__ + "media/images/banners/bnr_2week_makanai-384654d037450b88101061bb1c90fc82.jpg";